// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

export const isGetEngagementRemoteFilterShellsResult = arrayOf(
  objectOf({
    filter_key: string,
    display_name: string,
    varies_by_app_group: boolean,
    allowed_for_territories: boolean,
    only_for_workflow_step: boolean,
    allowed_for_predictions: boolean,
  })
);
